import RestRepository from '@candybox/repository/rest.js';
import categoryMap from '@app/category/requests/category-repository';
import { singleton } from '@candybox/helpers.js';
import Category from "@app/category/documents/category";


export default singleton(() => {
    return new RestRepository(Category, categoryMap());
});
